"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.persistGeo = void 0;
const URLS_EXCLUDED = {
    dev: ['/baf/', '/baf'],
    qa: ['/next13/compra/baf/', '/next13/compra/bafAutonomos/'],
    prod: ['/next13/compra/baf/', "/particulares/order/baf/", "/order/au/baf/"],
};
const DEFAULT_GEO = {
    cp: "28030",
    zone: "ZL",
    municipio: "",
    businessZones: [],
    x: "",
    mobile: false,
};
const persistGeo = ({ persistedInfo, checkCPAndSetZones, setCpParams, 
// cookies
ad_storage, analytics_storage, }) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const urlString = window.location.href;
    const url = new URL(urlString);
    const zone = url.searchParams.get("zone");
    const currentEnv = process.env.NEXT_PUBLIC_ENV_NAME;
    const isUrlExcluded = (_a = URLS_EXCLUDED[currentEnv]) === null || _a === void 0 ? void 0 : _a.includes(url === null || url === void 0 ? void 0 : url.pathname);
    const validCookies = ad_storage === "granted" && analytics_storage === "granted";
    const wrongCookies = ad_storage === "denied" || analytics_storage === "denied";
    const hasGeoProperPersistedInfo = persistedInfo && persistedInfo.geo && persistedInfo.geo.x !== "";
    const maybeChange = persistedInfo && persistedInfo.geo && persistedInfo.geo.maybeChange;
    /* ------------------- funcionalidad de sobrescribir zonas ------------------ */
    if (zone && (zone === "ZL" || zone === "ZR") && !isUrlExcluded) {
        switch (zone) {
            case "ZR":
                const infoRegulada = yield (Promise.resolve().then(() => __importStar(require('./regulada_zone.json'))));
                setCpParams(infoRegulada);
                break;
            case "ZL":
            default:
                setCpParams({ cp: "28030", zone: "ZL", municipio: "", businessZones: [], persist: true });
                break;
        }
    }
    else if ((!hasGeoProperPersistedInfo || maybeChange) && validCookies) {
        /* --------- si tenemos cookies aceptadas hacemos la petición al geo -------- */
        checkCPAndSetZones(Object.assign(Object.assign({}, DEFAULT_GEO), { cp: "", maybeChange: false }));
    }
    else {
        /* ------------------------- mantener los persistido ------------------------ */
        let geo = Object.assign({}, DEFAULT_GEO);
        if (persistedInfo && persistedInfo.geo) {
            geo = Object.assign(Object.assign(Object.assign({}, DEFAULT_GEO), persistedInfo.geo), { maybeChange: wrongCookies });
        }
        setCpParams(Object.assign(Object.assign({}, geo), { persist: true }));
    }
});
exports.persistGeo = persistGeo;
exports.default = exports.persistGeo;
//# sourceMappingURL=index.js.map